import React from 'react';

/** Lazy ClientComputedLinks (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedLinks = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-links' */
            './ClientComputedLinks'
        ),
);
